class SliderProduct extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
    this._onResize = this._onResize.bind(this);
  }

  connectedCallback() {
    this.setup();
    this.loadRecommendations();
    window.addEventListener("resize", this._onResize);
  }

  disconnectedCallback() {
    window.removeEventListener("resize", this._onResize);
    this.destroySwiper();
  }

  _onResize() {
    this.setup();
  }

  isMobile() {
    return window.innerWidth < 990;
  }

  mobileGridEnabled() {
    return this.dataset.mobileGrid === "true";
  }

  setup() {
    if (this.isMobile() && this.mobileGridEnabled()) {
      this.destroySwiper();
      return;
    }

    if (!this.swiper) {
      this.initSlider();
    } else {
      this.swiper.update();
      this.equalizeSlideHeights();
    }
  }

  getRecommendationsUrl() {
    const section = this.closest("[data-section-id]");
    return section?.dataset?.url || "";
  }

  loadRecommendations() {
    const url = this.getRecommendationsUrl();
    if (!url) return;

    fetch(url, {
      headers: { "X-Requested-With": "XMLHttpRequest" },
      cache: "no-store",
    })
      .then((r) => r.text())
      .then((htmlText) => {
        const tmp = document.createElement("div");
        tmp.innerHTML = htmlText;

        const fresh = tmp.querySelector("[data-slider-wrapper]");
        const current = this.querySelector("[data-slider-wrapper]");
        if (!fresh || !current) return;

        const freshHtml = fresh.innerHTML.trim();
        if (!freshHtml.length) return;

        this.destroySwiper();
        current.innerHTML = freshHtml;
        this.setup();
        this.equalizeSlideHeights();
      })
      .catch((e) => console.error(e));
  }

  initSlider() {
    const sliderElement = this.querySelector(".swiper-product-card");
    if (!sliderElement) return;

    this.swiper = new Swiper(sliderElement, {
      slidesPerView: "auto",
      spaceBetween: 6,
      freeMode: {
        enabled: true,
        sticky: true,
        momentumRatio: 0.5,
      },
      mousewheel: {
        forceToAxis: true,
        thresholdDelta: 15,
        thresholdTime: 100,
        releaseOnEdges: true,
      },

      pagination: {
        el: this.querySelector(".swiper-pagination"),
        clickable: true,
      },

      navigation: {
        nextEl: this.querySelector(".swiper-button-next"),
        prevEl: this.querySelector(".swiper-button-prev"),
      },

      breakpoints: {
        990: {
          spaceBetween: 18,
        },
      },

      on: {
        init: () => this.equalizeSlideHeights(),
        imagesReady: () => this.equalizeSlideHeights(),
        slideChangeTransitionEnd: () => this.equalizeSlideHeights(),
        resize: () => this.equalizeSlideHeights(),
      },
    });
  }

  destroySwiper() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }

  equalizeSlideHeights() {
    if (this.isMobile() && this.mobileGridEnabled()) return;

    const isMobile = window.innerWidth < 990;
    const slides = this.querySelectorAll(".swiper-product-card .swiper-slide");
    if (!slides.length) return;

    slides.forEach((s) => (s.style.height = "auto"));
    if (!isMobile) return;

    let maxH = 0;
    slides.forEach((s) => {
      const h = s.offsetHeight;
      if (h > maxH) maxH = h;
    });

    slides.forEach((s) => (s.style.height = `${maxH}px`));
  }
}

customElements.define("slider-product", SliderProduct);
